module.exports = __webpack_public_path__ + "static/media/money_category.f4e34976.jpg";